<template>
  <div class="house-withdraw-form">
    <el-dialog
      title="房源下架"
      :close-on-click-modal="false"
      @close="close"
      :before-close="close"
      visible
    >
      <span class="title-alert"
        >注意：仅待运营/空置/已冻结状态下的房源可下架</span
      >
      <el-form
        inline
        ref="formData"
        :rules="rules"
        :model="formData"
        label-width="110px"
        label-position="right"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="房源类型" class="half-line" prop="houseType">
              <el-select
                v-model="formData.houseType"
                @change="getValue"
                placeholder="请选择房源类型"
              >
                <el-option
                  v-for="(item, index) in houseTypeEum"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属片区" class="half-line" prop="belongZone">
              <el-cascader
                :options="zoneList"
                :props="props"
                @change="handleChange"
                placeholder="请选择片区"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(tip, index) in formData.houseArrayJson" :key="index">
          <el-col :span="21">
            <el-form-item
              :label="houseTitle(index)"
              class="all-line"
              :prop="'houseArrayJson.' + index + '.houseItem'"
              :rules="rules.houseItem"
            >
              <el-select
                v-model="tip.houseSpaceId"
                filterable
                remote
                class="inline-input"
                placeholder="请输入搜索房源地址"
                :remote-method="
                  queryString => houseInformSearch(queryString, tip)
                "
                :loading="companyLoading"
                @change="houseSelect(tip, index)"
              >
                <el-option
                  v-for="(item, key) in tip.options4"
                  :key="key"
                  :label="item.keywordAddress"
                  :value="item.houseSpaceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button
              v-if="index !== 0"
              size="small"
              class="delete-button"
              @click="deleteHouse(index)"
              type="danger"
              >删除</el-button
            >
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="图片说明" prop="imageCheck">
            <!-- 饿了么上传图片控件 -->
            <el-upload
              :action="ossBaseUrl"
              accept="image/*"
              list-type="picture-card"
              :auto-upload="false"
              :on-remove="handleRemove"
              :on-change="changeFileList"
              :fileList="fileList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注说明" class="all-line" prop="remarks">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入备注内容"
                v-model="formData.remarks"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="add-house" @click="addNewWithdrawHouse"
          >新增下架房源</el-button
        >
        <el-button
          type="primary"
          :loading="isLoading"
          @click="submit('formData')"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import co from 'co'
import OSS from 'ali-oss'
import accountApi from '@/xhr/services/account'
import houseApi from '@/xhr/services/house'
import { houseTypeEum } from './enum.js'
import { startForm } from './api/index'
import { k1 } from '@/xhr/services/osssp'

export default {
  data() {
    var zoneCheck = (rule, value, callback) => {
      let { unitId } = this.formData
      if (!unitId || unitId.length < 2) {
        callback('请选择归属片区')
      } else if (Array.isArray(unitId) && unitId.length === 2) {
        callback()
      }
    }
    var houseItem = (rule, value, callback) => {
      let { houseArrayJson } = this.formData
      let { fullField } = rule
      let index = fullField.split('.')[1]
      if (!houseArrayJson[index].houseSpaceId) {
        callback('请输入下架房间地址')
      } else if (
        houseArrayJson.filter(
          item => item.houseSpaceId === houseArrayJson[index].houseSpaceId
        ).length >= 2
      ) {
        callback('输入房源不能重复')
      } else {
        callback()
      }
    }
    return {
      originAddress: '',
      ossBaseUrl: 'http://' + k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6 + '.' + k1.a_4 + '-' + k1.a_3 + '-' + k1.a_0 + '.' + k1.a_2 + k1.a_8 + k1.a_1 + '.com/',
      fileList: [],
      houseTypeEum,
      formData: {
        houseType: '', // 房源类型
        unitId: [], // 片区ID
        unitName: '', // 片区名称
        houseArrayJson: [
          {
            houseSpaceId: '', // 房源Id
            houseSpaceName: '', // 房源名称
            options4: [],
          },
        ], // 房源列表
        image: [], // 说明图片
        remarks: '', // 备注
      },
      isLoading: false,
      companyLoading: false,
      zoneList: [],
      houseList: [],
      props: {
        value: 'id',
        label: 'text',
      },
      waiter: null,
      rules: {
        houseType: [
          { required: true, message: '请选择房源类型', trigger: 'onchange' },
        ],
        belongZone: [{ required: true, validator: zoneCheck }],
        houseItem: [{ required: true, validator: houseItem }],
        remarks: [{ required: true, message: '请填写备注说明' }],
      },
    }
  },
  props: {},
  watch: {},
  created() {
    this.getScopeId()
  },
  computed: {},
  methods: {
    close() {
      // let val = 'addCompany'
      console.log(12)
      this.$emit('closeHouseWithdraw')
    },
    houseTitle(index) {
      return `下架房间 ${index + 1}`
    },
    // 新增下架房源
    addNewWithdrawHouse() {
      let newHouse = {
        houseSpaceId: '', // 房源Id
        houseSpaceName: '', // 房源名称
      }
      this.formData.houseArrayJson.push(newHouse)
    },
    // 删除指定的下架房源
    deleteHouse(index) {
      console.log(index)
      console.log(this.formData.houseArrayJson)
      this.formData.houseArrayJson.splice(index, 1)
    },
    // 改变文件列表
    changeFileList(file, fileList) {
      // (raw, name, size, uid, url)
      this.fileList = fileList
      // this.$refs.formData.validateField('companyFileList')
    },
    // 删除图片文件
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    // 根据本地图片列表上传
    uploadFileList(fileList) {
      const registerToken = fileCount => {
        return new Promise((resolve, reject) => {
          this.$http
            .post(this.urljoin(this.urlList.pdf, 'token'), {
              fileCount,
              ossType: 'image',
            })
            .then(res => {
              if (res.data.code !== 200) {
                this.$message.error(`上传失败。原因：${res.data.message}`)
                reject()
              } else {
                resolve(res.data.data)
              }
            })
        })
      }

      return new Promise((resolve, reject) => {
        registerToken(fileList.length).then(({ key, secret, fileNames }) => {
          const client = new OSS({
            region: k1.a_4 + '-cn-' + k1.a_0,
            accessKeyId: key,
            accessKeySecret: secret,
            bucket: k1.a_7 + '-' + k1.a_5 + k1.a_9 + '-' + k1.a_6
          })

          co(function*() {
            let ret = []
            for (let i = 0; i < fileNames.length; i++) {
              const o = yield client.put(fileNames[i], fileList[i].raw)
              ret.push(o)
            }
            resolve(ret)
          }).catch(err => {
            this.$message.error(`OSS上传失败。原因：${err.code}`)
            reject()
          })
        })
      })
    },
    handleChange(val) {
      // console.log(this.zoneList)
      // console.log(val[1] === this.formData.unitId[1])
      if (val.length === 2 && val[1] !== this.formData.unitId[1]) {
        this.formData.unitId = val
        this.formData.houseArrayJson = [
          {
            houseSpaceId: '',
            houseSpaceName: '',
            options4: [],
          },
        ]
      }
    },
    getValue(val) {
      console.log(val)
      this.formData.houseArrayJson = [
        {
          houseSpaceId: '',
          houseSpaceName: '',
          options4: [],
        },
      ]
    },
    // 获取片区对应的片区命
    getZoneName(zoneId) {
      let unitName = ''
      if (this.zoneList.length) {
        this.zoneList.forEach(item => {
          if (
            item.children &&
            Array.isArray(item.children) &&
            item.children.length
          ) {
            item.children.forEach(tip => {
              if (tip.id === zoneId) {
                unitName = tip.text
              }
            })
          }
        })
      }
      return unitName
    },
    // 搜索房间接口函数
    houseInformSearch(queryString, tip) {
      // console.log(queryString, tip)
      // console.log(this.$refs.tip)
      if (queryString !== '') {
        this.companyLoading = true
        clearTimeout(this.waiter)
        this.waiter = setTimeout(() => {
          let str = queryString.replace(/^\s*|\s*$/g, '')
          let params = {
            houseSpaceManagerType: this.formData.houseType,
            keyword: str,
            unitId: this.formData.unitId[1],
          }
          houseApi.getHouseSpace(params).then(res => {
            // console.log(res)
            this.companyLoading = false
            if (res.data.code === 200) {
              tip.options4 = res.data.data
            } else {
              tip.options4 = []
            }
          })
        }, 500)
      }
    },
    // 选择房间
    houseSelect(tip, index) {
      let selectedObj = tip.options4.find(
        item => item.houseSpaceId === tip.houseSpaceId
      )
      console.log(selectedObj)
      tip.houseSpaceName = selectedObj.keywordAddress
      console.log(this.formData)
    },
    // 加工 流程摘要
    getDocumentation() {
      let { houseArrayJson } = this.formData
      let documentation = ''
      if (
        houseArrayJson &&
        Array.isArray(houseArrayJson) &&
        houseArrayJson.length
      ) {
        houseArrayJson.forEach(item => {
          documentation += `${item.houseSpaceName},`
        })
      }
      if (documentation) {
        documentation = documentation.substr(0, documentation.length - 1)
      }
      return documentation
    },
    // 提交
    submit(val) {
      this.$refs[val].validate(valid => {
        if (valid) {
          this.isLoading = true
          let { houseArrayJson, houseType, remarks, unitId } = this.formData
          let params = {
            houseType: JSON.stringify(
              this.houseTypeEum.find(item => item.id === houseType)
            ),
            unitId: unitId[1],
            unitName: this.getZoneName(unitId[1]),
            houseArrayJson: JSON.stringify(houseArrayJson),
            documentation: this.getDocumentation(), // 流程摘要
            image: '[]',
            remarks,
          }
          let startParams = {
            initiator: this.$store.state.currentUser.uid, // 当前用户
            processBusinessKey: 'process-house-off-shelves-v1', // 流程key
            processInstanceName: 'form-house-off-shelves-start', // 流程名称
            processScopeId: unitId[1], // 片区id
            variables: params,
          }
          console.log(startParams)
          if (this.fileList && this.fileList.length) {
            this.uploadFileList(this.fileList).then(res => {
              const urls = res.map(item => item.url)
              startParams.variables.image = JSON.stringify(urls)
              this.startProcess(startParams)
            })
          } else {
            this.startProcess(startParams)
          }
        }
      })
    },
    // 发起流程
    async startProcess(startParams) {
      try {
        await startForm(
          startParams,
          this.formData.houseArrayJson.map(o => o.houseSpaceId)
        )
        this.close()
        this.$message.success('提交成功')
      } catch (error) {
        console.log(error.message)
        this.$confirm(error.message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } finally {
        this.isLoading = false
      }
    },
    // 获取登录人权限下的片区集合
    getScopeId() {
      let userId = this.$store.state.currentUser.uid
      accountApi.getZoneIdByUserId(userId).then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          this.zoneList = res.data.data
        } else {
          this.zoneList = []
        }
      })
    },
  },
  filters: {
    // dealWithBlank, // 去除字符串两端空格
  },
}
</script>
<style lang="scss" scoped>
.house-withdraw-form {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #333333;
  position: relative;
  .all-line {
    width: 100%;
    .inline-input {
      width: 100%;
    }
  }
  .title-alert {
    position: relative;
    font-size: 14px;
    color: red;
    font-weight: bold;
    top: -52px;
    left: 80px;
  }
  .delete-button {
    position: relative;
    top: 4px;
    left: 5px;
  }
  .add-house {
    position: absolute;
    left: 20px;
  }
}
</style>
<style>
/* 修改 element-ui 样式 */
.house-withdraw-form .all-line .el-form-item__content {
  width: 77.5%;
}
.house-withdraw-form .all-line .el-form-item__content .el-cascader {
  width: 100%;
}
.house-withdraw-form .el-input__icon + .el-input__inner {
  padding-right: 10px;
}
.house-withdraw-form .el-dialog {
  width: 665px !important;
}
.house-withdraw-form .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
}
/* 红色按钮样式 */
.house-withdraw-form .delete-button:active {
  color: #fff;
  border-color: #e64242;
}
.house-withdraw-form .delete-button:hover {
  color: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
.house-withdraw-form .delete-button:focus {
  background: #ff6d6d;
  border-color: #ff6d6d;
  color: #fff;
}
</style>
<style lang="scss">
.house-withdraw-form {
  .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 110px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/HouseWithdrawForm/index.vue